/**
 * Deduplicates an array of objects based on a key extracted by the provided function
 * @param array - Array of objects to deduplicate
 * @param getKey - Function that extracts the unique key from each object
 * @returns Deduplicated array (keeps first occurrence of each unique key)
 */
export function deduplicateArray<T, K>(array: T[], getKey: (item: T) => K): T[] {
  const seenKeys = new Map<K, T>();

  array.forEach((item) => {
    const key = getKey(item);
    if (!seenKeys.has(key)) {
      seenKeys.set(key, item);
    }
  });

  return Array.from(seenKeys.values());
}
